import b from 'b_';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { RADIO_SIZES, RADIO_THEMES, RADIO_TYPES, CONTROL_GROUP_ALIGNS } from '../constants';

import './radio-group.scss';

class RadioGroup extends React.Component {
    static propTypes = {
        align: PropTypes.oneOf(Object.values(CONTROL_GROUP_ALIGNS)),
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
        disabled: PropTypes.bool,
        mix: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        name: PropTypes.string,
        onChange: PropTypes.func,
        options: PropTypes.arrayOf(PropTypes.object),
        size: PropTypes.oneOf(Object.values(RADIO_SIZES)),
        theme: PropTypes.oneOf(Object.values(RADIO_THEMES)),
        type: PropTypes.oneOf(Object.values(RADIO_TYPES)),
        value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
        role: PropTypes.string,
        'aria-label': PropTypes.string,
    };

    static defaultProps = {
        align: CONTROL_GROUP_ALIGNS.VERTICAL,
        size: RADIO_SIZES.MEDIUM,
        theme: RADIO_THEMES.NORMAL,
        type: RADIO_TYPES.RADIO,
    };

    onChange = (e) => {
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    };

    render() {
        const {
            align,
            children,
            disabled,
            mix,
            name,
            size,
            theme,
            type,
            value,
            role = 'radiogroup',
            'aria-label': ariaLabel,
        } = this.props;
        const className = cx(mix, b('radio-group', { align, disabled, size, theme, type }));

        return (
            <span aria-label={ariaLabel} className={className} name={name} onChange={this.onChange} role={role}>
                {React.Children.map(
                    children,
                    function (item) {
                        const { props: itemProps } = item;
                        return React.cloneElement(item, {
                            checked: value !== undefined && String(value) === String(itemProps.value),
                            disabled: itemProps.disabled || disabled,
                            focused: itemProps.focused && !disabled,
                            key: itemProps.value,
                            name,
                            size,
                            theme,
                            value: itemProps.value,
                            type,
                        });
                    },
                    this
                )}
            </span>
        );
    }
}

export default RadioGroup;
export { default as Radio } from '../radio/radio';
